import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import LowResolutionPage from "./LowResolutionPage";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<div></div>}>
			<App />
		</Suspense>
	</React.StrictMode>,
	document.getElementById("root")
);

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<div></div>}>
			<LowResolutionPage />
		</Suspense>
	</React.StrictMode>,
	document.getElementById("low-resolution-page")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();